var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"likes"},[_c('el-icon',{attrs:{"name":"heart"},on:{"click":_vm.addLike}}),_vm._v("\n    "+_vm._s(_vm.likes)+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"views"},[_c('el-icon',{attrs:{"name":"view"}}),_vm._v("\n    "+_vm._s(_vm.views)+"\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bfa03e3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/login/Login.vue
// module id = null
// module chunks = 